import styled from 'styled-components'

export const NavigationButtonBase = styled.div`
  align-items: center;
  border-radius: 50px;
  border: 2px solid ${({ theme }) => theme.colors.grey5};
  cursor: pointer;
  display: flex;
  height: 48px;
  justify-content: center;
  width: 48px;

  &:hover,
  &:active,
  &:focus {
    background-color: ${({ theme }) => theme.colors.grey6};
    border: 2px solid ${({ theme }) => theme.colors.grey2};
  }
`
